import React from "react";
import { IVehicle, ICoverage, IQuoteApiClient } from "../classes/Domain";
import Select, { ValueType, ActionMeta } from "react-select"
import VehicleExplorer from "../classes/VehicleExplorer";
import * as _ from 'lodash';
import { validationUtils } from "../validation/Validation";
import { Form, Row, Col, Button } from 'react-bootstrap';

const isEmpty = (str) => (!str?.length);

const VEHICLE_OPTION_TYPES = {
    YEAR: "YEAR",
    MAKE: "MAKE",
    MODEL: "MODEL",
    BODY: "BODY",
    ENGINE: "ENGINE",
    CYLINDERS: "CYLINDERS",
    SPECS: "SPECS",
    FINISH: "FINISH",
    COVERAGES: "COVERAGES"
};

const NO_OPTIONS = "No_options";

const START_YEAR = 1980;

type VehicleOption = {
    value: string,
    label: string,
    type: string
}

type OptionsGroup = {
    label: string,
    options: Array<VehicleOption>;
}

class VinRecord {
    year: number;
    make: string;
    model: string;
    body: string;
    engineSize: string;
    specsCombined: string;
    vin: string;
    cylinders: number;
    antiThft: string;
    compSymbol: string;
    collSymbol: string;
    costNewId: string;

    constructor() {
        this.year = 0;
        this.cylinders = 0;
        this.make = "";
        this.model = "";
        this.body = "";
        this.engineSize = "";
        this.specsCombined = "";
        this.vin = "";
        this.antiThft = "";
        this.compSymbol = "";
        this.collSymbol = "";
        this.costNewId = "";
    }
}

const coverages: Array<VehicleOption> = [
    { label: "Liability Only", value: "0", type: VEHICLE_OPTION_TYPES.COVERAGES },
    { label: "$500 Ded", value: "500", type: VEHICLE_OPTION_TYPES.COVERAGES },
    { label: "$750 Ded", value: "750", type: VEHICLE_OPTION_TYPES.COVERAGES },
    { label: "$1000 Ded", value: "1000", type: VEHICLE_OPTION_TYPES.COVERAGES },
    { label: "$1500 Ded", value: "1500", type: VEHICLE_OPTION_TYPES.COVERAGES },
    { label: "$2000 Ded", value: "2000", type: VEHICLE_OPTION_TYPES.COVERAGES }
];
interface IProps {
    updatingStore?: boolean,
    quoteUid: string,
    quoteId: number,
    vehicle: IVehicle | null,
    vehicleIndex: number,
    isActive: boolean,
    errors: any,
    quoteApiClient: IQuoteApiClient,
    onVehicleChange(vehicle: IVehicle, index: number): void,
    onVehicleDelete(index: number): void,
    getQuickVehicleCoverages: () => Array<ICoverage>;
}

interface IState {
    selectedOptions: Array<VehicleOption>,
    menuYearIsOpen: boolean,
    menuMakeIsOpen: boolean,
    menuModelIsOpen: boolean,
    menuBodyIsOpen: boolean,
    menuCoverageIsOpen: boolean,
    loadingOptionsMake: boolean,
    loadingOptionsModel: boolean,
    loadingOptionsBody: boolean,
    loadingOptionsCovs: boolean,
    saveAndContinue: boolean,
    updatingAppState: boolean,
    options: Array<OptionsGroup>,
    propsMerged: boolean,
    isActive: boolean,
    vehicle: IVehicle;
}

class VehicleSelectByStep extends React.Component<IProps, IState> {
    selectYearRef: React.RefObject<Select>;
    selectMakeRef: React.RefObject<Select>;
    selectModelRef: React.RefObject<Select>;
    selectBodyRef: React.RefObject<Select>;
    selectCoverageRef: React.RefObject<Select>;
    vehicleExplorer: VehicleExplorer;
    vinRecords: Array<VinRecord>;
    apiClient: IQuoteApiClient;

    constructor(props: IProps) {
        super(props);
        this.selectYearRef = React.createRef();
        this.selectMakeRef = React.createRef();
        this.selectModelRef = React.createRef();
        this.selectBodyRef = React.createRef();
        this.selectCoverageRef = React.createRef();
        this.apiClient = this.props.quoteApiClient;
        this.vehicleExplorer = new VehicleExplorer();
        this.vinRecords = [];

        this.yearStepHandler = this.yearStepHandler.bind(this);
        this.makeStepHandler = this.makeStepHandler.bind(this);
        this.modelStepHandler = this.modelStepHandler.bind(this);
        this.bodyStepHandler = this.bodyStepHandler.bind(this);
        this.engineStepHandler = this.engineStepHandler.bind(this);
        this.cylindersStepHandler = this.cylindersStepHandler.bind(this);
        this.specsStepHandler = this.specsStepHandler.bind(this);
        this.coverageStepHandler = this.coverageStepHandler.bind(this);
        this.finishStepHandler = this.finishStepHandler.bind(this);

        this.vehicleExplorer.addVehicleExploreStep(VEHICLE_OPTION_TYPES.YEAR, this.yearStepHandler);
        this.vehicleExplorer.addVehicleExploreStep(VEHICLE_OPTION_TYPES.MAKE, this.makeStepHandler);
        this.vehicleExplorer.addVehicleExploreStep(VEHICLE_OPTION_TYPES.MODEL, this.modelStepHandler);
        this.vehicleExplorer.addVehicleExploreStep(VEHICLE_OPTION_TYPES.BODY, this.bodyStepHandler);
        this.vehicleExplorer.addVehicleExploreStep(VEHICLE_OPTION_TYPES.ENGINE, this.engineStepHandler);
        this.vehicleExplorer.addVehicleExploreStep(VEHICLE_OPTION_TYPES.CYLINDERS, this.cylindersStepHandler);
        this.vehicleExplorer.addVehicleExploreStep(VEHICLE_OPTION_TYPES.SPECS, this.specsStepHandler);
        this.vehicleExplorer.addVehicleExploreStep(VEHICLE_OPTION_TYPES.COVERAGES, this.coverageStepHandler);
        this.vehicleExplorer.addVehicleExploreStep(VEHICLE_OPTION_TYPES.FINISH, this.finishStepHandler);

        this.state = {
            selectedOptions: [],
            menuYearIsOpen: false,
            menuMakeIsOpen: false,
            menuModelIsOpen: false,
            menuBodyIsOpen: false,
            menuCoverageIsOpen: false,
            loadingOptionsMake: false,
            loadingOptionsModel: false,
            loadingOptionsBody: false,
            loadingOptionsCovs: false,
            saveAndContinue: false,
            updatingAppState: false,
            propsMerged: false,
            options: [],
            isActive: this.props.isActive,
            vehicle: this.props.vehicle ?? {} as IVehicle
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.propsMerged) return prevState;
        const vehicle = nextProps.vehicle as IVehicle;;

        if (vehicle && vehicle.year > 0) {
            let selectedOptions = [{ value: vehicle.year.toString(), label: vehicle.year.toString(), type: VEHICLE_OPTION_TYPES.YEAR }];

            if (vehicle.make) {
                selectedOptions.push({ value: vehicle.make, label: vehicle.make, type: VEHICLE_OPTION_TYPES.MAKE })

                if (vehicle.model) {
                    selectedOptions.push({ value: vehicle.model, label: vehicle.model, type: VEHICLE_OPTION_TYPES.MODEL })

                    if (vehicle.body) {
                        selectedOptions.push({ value: vehicle.body, label: vehicle.body, type: VEHICLE_OPTION_TYPES.BODY })

                        if (vehicle.engineSize) {
                            selectedOptions.push({ value: vehicle.engineSize, label: vehicle.engineSize, type: VEHICLE_OPTION_TYPES.ENGINE })

                            if (vehicle.cylinders > 0) {
                                selectedOptions.push({ value: vehicle.cylinders?.toString(), label: vehicle.cylinders?.toString(), type: VEHICLE_OPTION_TYPES.CYLINDERS })

                                if (vehicle.specs !== '') {
                                    selectedOptions.push({ value: vehicle.specs, label: vehicle.specs, type: VEHICLE_OPTION_TYPES.SPECS })

                                    if (vehicle.coverages && vehicle.coverages?.length > 0) {
                                        var selected = vehicle.coverages.filter(x => x.isSelected);

                                        if (selected.length > 0) {
                                            var limit = coverages.filter(x => x.value === selected[0].value);

                                            if (limit.length > 0) {
                                                selectedOptions.push(limit[0]);
                                            }
                                        }
                                        else {
                                            selectedOptions.push(coverages[0]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            const nextState = {
                ...prevState,
                vehicle: vehicle,
                selectedOptions: selectedOptions,
                propsMerged: true
            };

            return nextState;
        }

        return prevState;
    }

    componentDidMount() {
        if (this.state.selectedOptions.length) {
            const lastSelectedOption = this.state.selectedOptions[this.state.selectedOptions.length - 1];

            const nextStep = this.vehicleExplorer.findNextStepFor(lastSelectedOption.type);
            if (nextStep) {
                nextStep.handler(lastSelectedOption.value);
            }
        } else {
            const nextStep = this.vehicleExplorer.findStepByType(VEHICLE_OPTION_TYPES.YEAR);
            if (nextStep) {
                nextStep.handler();
            }
        }
    }

    getVinRecords(year: number, make: string, model: string) {
        if (0 === this.vinRecords.length) {
            return this.apiClient
                .getVinRecords(year, make, model, this.props.quoteUid, null)
                .then((response) => {
                    if (response.data.options && 0 < response.data.options.length) {
                        this.vinRecords = _.map(response.data.options,
                            (o) => {
                                var r = new VinRecord();
                                r.year = o.year;
                                r.make = o.make;
                                r.model = o.model;
                                r.body = o.body;
                                r.engineSize = o.engineSize;
                                r.cylinders = o.cylinders;
                                r.specsCombined = o.specsCombined;
                                r.vin = o.vin;
                                r.antiThft = o.antiThft;
                                r.compSymbol = o.compSymbol;
                                r.collSymbol = o.collSymbol;
                                return r;
                            });
                    }
                    return this.vinRecords;
                });
        } else {
            return (Promise.resolve(this.vinRecords));
        }
    }

    updateGlobalVehicleState(vehicle: IVehicle, index: number, doing: boolean) {
        return new Promise((resolve, reject) => {
            if (doing) {
                this.props.onVehicleChange(vehicle, index);
            }
            resolve();
        });
    }

    yearStepHandler() {
        const options: VehicleOption[] = [];
        for (let year = new Date().getFullYear(); year >= START_YEAR; year--) {
            options.push({
                value: year.toString(),
                label: year.toString(),
                type: VEHICLE_OPTION_TYPES.YEAR
            });
        }

        const yearOptions = [{ label: "Select car year", options: options }];
        this.setState({ ...this.state, vehicle: {} as IVehicle, options: yearOptions, menuYearIsOpen: this.state.menuYearIsOpen });
    }

    makeStepHandler(prevStepSelectedValue) {
        const checkValue = this.state.vehicle?.year ?? 0;
        const vehicleYear = parseInt(prevStepSelectedValue, 10) || checkValue;
        let updatedVehicle = Object.assign({}, { year: vehicleYear } as IVehicle);

        this.updateGlobalVehicleState(updatedVehicle, this.props.vehicleIndex, updatedVehicle.year !== checkValue).then(() => {
            this.setState({ ...this.state, vehicle: updatedVehicle, loadingOptionsMake: true, menuMakeIsOpen: false }, () => {
                this.apiClient
                    .getVehicleMakes(vehicleYear, this.props.quoteId, this.props.quoteUid)
                    .then((response) => {
                        var makeOptions = [
                            {
                                label: "Select make",
                                options: response.data.options.map(obj => ({
                                    ...obj, type: VEHICLE_OPTION_TYPES.MAKE
                                }))
                            }
                        ];

                        this.setState({ ...this.state, options: makeOptions, loadingOptionsMake: false, menuMakeIsOpen: true });
                    });
            });
        });
    }

    modelStepHandler(prevStepSelectedValue) {
        let updatedVehicle = Object.assign({}, this.state.vehicle);
        updatedVehicle.make = prevStepSelectedValue;
        updatedVehicle.model = '';
        const checkValue = this.state.vehicle?.make ?? '';

        this.updateGlobalVehicleState(updatedVehicle, this.props.vehicleIndex, updatedVehicle.make !== checkValue).then(() => {
            this.setState({ ...this.state, vehicle: updatedVehicle, loadingOptionsModel: true, menuModelIsOpen: false }, () => {
                this.apiClient
                    .getVehicleModels(this.state.vehicle.year, prevStepSelectedValue, this.props.quoteUid)
                    .then((response) => {
                        var modelOptions = [
                            {
                                label: "Select model",
                                options: response.data.options.map(obj => ({ ...obj, type: VEHICLE_OPTION_TYPES.MODEL }))
                            }
                        ];

                        this.setState({ ...this.state, options: modelOptions, loadingOptionsModel: false, menuModelIsOpen: true });
                    });
            });
        });
    }

    bodyStepHandler(prevStepSelectedValue) {
        let updatedVehicle = Object.assign({}, this.state.vehicle);
        updatedVehicle.model = prevStepSelectedValue;
        updatedVehicle.body = "";
        updatedVehicle.engineSize = "";
        updatedVehicle.cylinders = 0;
        updatedVehicle.specs = "";
        updatedVehicle.coverages = null;
        updatedVehicle.vin = "";
        const checkValue = this.state.vehicle?.model ?? '';

        this.updateGlobalVehicleState(updatedVehicle, this.props.vehicleIndex, updatedVehicle.model !== checkValue).then(() => {
            this.setState({ ...this.state, vehicle: updatedVehicle, loadingOptionsBody: true, menuBodyIsOpen: false }, () => {
                this.getVinRecords(this.state.vehicle.year, this.state.vehicle.make, prevStepSelectedValue)
                    .then(() => {
                        if (0 < this.vinRecords.length) {
                            const bodyGroups = _.groupBy(this.vinRecords, "body");
                            const bodyTypes = _.map(bodyGroups, (records, bodyType) => {
                                return {
                                    body: bodyType,
                                    count: records.length
                                }
                            });

                            if (1 === bodyTypes.length) {
                                const bodyTypeOption = { value: bodyTypes[0].body, label: bodyTypes[0].body, type: VEHICLE_OPTION_TYPES.BODY };
                                const extendedSelectedOptions = [...this.state.selectedOptions, bodyTypeOption];
                                this.setState({ selectedOptions: extendedSelectedOptions, loadingOptionsBody: false, menuBodyIsOpen: false }, () => {
                                    if (!this.vehicleExplorer.handleNextStepFor(VEHICLE_OPTION_TYPES.BODY, bodyTypeOption.value)) {
                                        this.handleError();
                                    }
                                });
                            } else if (1 < bodyTypes.length) {
                                const bodyTypeOptions = [
                                    {
                                        label: "Select body type",
                                        options: bodyTypes.map(t => ({ value: t.body, label: t.body, type: VEHICLE_OPTION_TYPES.BODY }))
                                    }
                                ];

                                this.setState({ ...this.state, options: bodyTypeOptions, loadingOptionsBody: false, menuBodyIsOpen: true });
                            }
                        }
                        else {
                            this.handleNoVehicleOptions();
                        }
                    });
            });
        });
    }

    engineStepHandler(prevStepSelectedValue) {
        let updatedVehicle = Object.assign({}, this.state.vehicle);
        updatedVehicle.body = prevStepSelectedValue;
        updatedVehicle.vin = "";
        const checkValue = this.state.vehicle?.body ?? '';

        this.updateGlobalVehicleState(updatedVehicle, this.props.vehicleIndex, updatedVehicle.body !== checkValue).then(() => {
            this.setState({ vehicle: updatedVehicle }, () => {
                this.getVinRecords(this.state.vehicle.year, this.state.vehicle.make, this.state.vehicle.model)
                    .then(() => {
                        if (0 < this.vinRecords.length) {
                            const records = _.filter(this.vinRecords, (record) => record.body === prevStepSelectedValue);
                            const engineGroups = _.groupBy(records, "engineSize");
                            const engineSizes = _.map(engineGroups, (coll, engineSize) => {
                                return {
                                    value: engineSize,
                                    label: engineSize,
                                    type: VEHICLE_OPTION_TYPES.ENGINE
                                }
                            });

                            if (1 <= engineSizes.length) {
                                const engineOption = engineSizes.sort((a, b) => (parseFloat(a.value) < parseFloat(b.value) ? -1 : 1))[0];
                                const extendedSelectedOptions = [...this.state.selectedOptions, engineOption];
                                this.setState({ selectedOptions: extendedSelectedOptions }, () => {
                                    if (!this.vehicleExplorer.handleNextStepFor(VEHICLE_OPTION_TYPES.ENGINE, engineOption.value)) {
                                        this.handleError();
                                    }
                                });
                            } else {
                                this.handleNoVehicleOptions();
                            }
                        }
                        else {
                            this.handleNoVehicleOptions();
                        }
                    });
            });
        });
    }

    cylindersStepHandler(prevStepSelectedValue) {
        let updatedVehicle = Object.assign({}, this.state.vehicle);
        updatedVehicle.engineSize = prevStepSelectedValue;
        updatedVehicle.vin = "";
        const checkValue = this.state.vehicle?.engineSize ?? '';

        this.updateGlobalVehicleState(updatedVehicle, this.props.vehicleIndex, updatedVehicle.engineSize !== checkValue).then(() => {
            this.setState({ vehicle: updatedVehicle }, () => {
                this.getVinRecords(this.state.vehicle.year, this.state.vehicle.make, this.state.vehicle.model)
                    .then(() => {
                        if (0 < this.vinRecords.length) {
                            const records = _.filter(this.vinRecords, (record) => record.body === this.state.vehicle.body
                                && record.engineSize === prevStepSelectedValue);

                            const cylinderGroups = _.groupBy(records, "cylinders");
                            const cylinders = _.map(cylinderGroups, (coll, cylinderCount) => {
                                return {
                                    value: cylinderCount.toString(),
                                    label: cylinderCount.toString(),
                                    type: VEHICLE_OPTION_TYPES.CYLINDERS
                                }
                            });

                            if (1 <= cylinders.length) {
                                const cylinderOption = cylinders.sort((a, b) => (parseFloat(a.value) < parseFloat(b.value) ? -1 : 1))[0];
                                const extendedSelectedOptions = [...this.state.selectedOptions, cylinderOption];
                                this.setState({ selectedOptions: extendedSelectedOptions }, () => {
                                    if (!this.vehicleExplorer.handleNextStepFor(VEHICLE_OPTION_TYPES.CYLINDERS, cylinderOption.value)) {
                                        this.handleError();
                                    }
                                });
                            }
                            else {
                                this.handleNoVehicleOptions();
                            }
                        }
                        else {
                            this.handleNoVehicleOptions();
                        }
                    });
            });
        });
    }

    specsStepHandler(prevStepSelectedValue) {
        let updatedVehicle = Object.assign({}, this.state.vehicle);
        updatedVehicle.cylinders = parseInt(prevStepSelectedValue, 10);
        updatedVehicle.vin = "";
        const checkValue = this.state.vehicle?.cylinders ?? 0;

        this.updateGlobalVehicleState(updatedVehicle, this.props.vehicleIndex, updatedVehicle.cylinders !== checkValue).then(() => {
            this.setState({ vehicle: updatedVehicle }, () => {
                this.getVinRecords(this.state.vehicle.year, this.state.vehicle.make, this.state.vehicle.model)
                    .then(() => {
                        if (0 < this.vinRecords.length) {
                            const records = _.filter(this.vinRecords, (record) => record.body === this.state.vehicle.body
                                && record.engineSize === this.state.vehicle.engineSize
                                && record.cylinders === parseInt(prevStepSelectedValue, 10)
                                && record.specsCombined.length > 0);

                            if (0 === records.length) {
                                const specOption = { value: "", label: "", type: VEHICLE_OPTION_TYPES.SPECS };
                                const extendedSelectedOptions = [...this.state.selectedOptions, specOption];
                                this.setState({ selectedOptions: extendedSelectedOptions }, () => {
                                    if (!this.vehicleExplorer.handleNextStepFor(VEHICLE_OPTION_TYPES.SPECS, "")) {
                                        this.handleError();
                                    }
                                });

                                return;
                            }

                            const specsGroups = _.groupBy(records, "specsCombined");
                            const specs = _.map(specsGroups, (coll, spec) => {
                                return {
                                    value: spec,
                                    label: spec,
                                    type: VEHICLE_OPTION_TYPES.SPECS
                                }
                            });

                            if (0 < specs.length) {
                                const specOption = specs[0];
                                const extendedSelectedOptions = [...this.state.selectedOptions, specOption];
                                this.setState({ selectedOptions: extendedSelectedOptions }, () => {
                                    if (!this.vehicleExplorer.handleNextStepFor(VEHICLE_OPTION_TYPES.SPECS, specOption.value)) {
                                        this.handleError();
                                    }
                                });
                            }
                            else {
                                this.handleNoVehicleOptions();
                            }
                        }
                        else {
                            this.handleNoVehicleOptions();
                        }
                    });
            });
        });
    }

    coverageStepHandler(prevStepSelectedValue) {
        let updatedVehicle = Object.assign({}, this.state.vehicle);
        updatedVehicle.specs = prevStepSelectedValue;

        let checkValue = this.state.vehicle?.specs ?? '';
        if ((updatedVehicle.specs === '' || updatedVehicle.specs === undefined)
            && (this.state.vehicle?.specs === '' || this.state.vehicle?.specs === undefined)) {
            updatedVehicle.specs = 'unspecified';
        }

        this.updateGlobalVehicleState(updatedVehicle, this.props.vehicleIndex, updatedVehicle.specs !== checkValue).then(() => {
            this.setState({ ...this.state, loadingOptionsCovs: true, vehicle: updatedVehicle, menuCoverageIsOpen: false }, () => {
                const coverageOptions = [{ label: "Select coverage", options: coverages }];

                if (updatedVehicle.vin) {
                    if (updatedVehicle.coverages) {
                        this.setState({ ...this.state, loadingOptionsCovs: false, options: coverageOptions, menuCoverageIsOpen: true });
                    }
                    else {
                        const defaultCoverageOption = { value: coverageOptions[0].options[0].value, label: coverageOptions[0].options[0].label, type: VEHICLE_OPTION_TYPES.COVERAGES };
                        const extendedSelectedOptions = [...this.state.selectedOptions, defaultCoverageOption];

                        this.setState({ loadingOptionsCovs: false, vehicle: updatedVehicle, options: coverageOptions, selectedOptions: extendedSelectedOptions, menuCoverageIsOpen: false }, () => {
                            if (!this.vehicleExplorer.handleNextStepFor(VEHICLE_OPTION_TYPES.COVERAGES, defaultCoverageOption.value)) {
                                this.handleError();
                            }
                        });
                    }
                }
                else {
                    this.getVinRecords(this.state.vehicle.year, this.state.vehicle.make, this.state.vehicle.model)
                        .then(() => {
                            if (0 < this.vinRecords.length) {
                                let records: Array<VinRecord> = [];

                                if (this.state.vehicle.specs === 'unspecified') {
                                    records = _.filter(this.vinRecords, (record) => record.body === this.state.vehicle.body
                                        && record.engineSize === this.state.vehicle.engineSize
                                        && record.cylinders === this.state.vehicle.cylinders);
                                }
                                else {
                                    records = _.filter(this.vinRecords, (record) => record.body === this.state.vehicle.body
                                        && record.engineSize === this.state.vehicle.engineSize
                                        && record.cylinders === this.state.vehicle.cylinders
                                        && record.specsCombined === this.state.vehicle.specs);
                                }

                                if (0 === records.length) {
                                    this.handleNoVehicleOptions();
                                } else {
                                    updatedVehicle.vin = records[0].vin;

                                    if (updatedVehicle.coverages) {
                                        this.setState({ ...this.state, loadingOptionsCovs: false, vehicle: updatedVehicle, options: coverageOptions, menuCoverageIsOpen: true });
                                    }
                                    else {
                                        const defaultCoverageOption = { value: coverageOptions[0].options[0].value, label: coverageOptions[0].options[0].label, type: VEHICLE_OPTION_TYPES.COVERAGES };
                                        const extendedSelectedOptions = [...this.state.selectedOptions, defaultCoverageOption];

                                        this.setState({ loadingOptionsCovs: false, vehicle: updatedVehicle, options: coverageOptions, selectedOptions: extendedSelectedOptions, menuCoverageIsOpen: false }, () => {
                                            if (!this.vehicleExplorer.handleNextStepFor(VEHICLE_OPTION_TYPES.COVERAGES, defaultCoverageOption.value)) {
                                                this.handleError();
                                            }
                                        });
                                    }
                                }
                            }
                            else {
                                this.handleNoVehicleOptions();
                            }
                        });
                }
            });
        });
    }

    finishStepHandler(prevStepSelectedValue) {
        let updatedVehicle = Object.assign({}, { ...this.state.vehicle, coverages: this.state.vehicle.coverages ?? this.props.getQuickVehicleCoverages() });

        let coverageChanged = this.state.vehicle.coverages ? false : true;
        for (let i = 0; i < updatedVehicle.coverages.length; i++) {
            let cov = updatedVehicle.coverages[i];
            if (cov.code === 'COMP' || cov.code === 'COLL') {
                if (cov.value === prevStepSelectedValue) {
                    if (cov.isSelected === false) {
                        coverageChanged = true;
                    }
                    cov.isSelected = true;
                }
                else {
                    if (cov.isSelected === true) {
                        coverageChanged = true;
                    }
                    cov.isSelected = false;
                }
            }
        }

        this.updateGlobalVehicleState(updatedVehicle, this.props.vehicleIndex, coverageChanged).then(() => {
            this.setState({ vehicle: updatedVehicle, menuCoverageIsOpen: false });
        })
    }

    handleNoVehicleOptions() {
        this.setState({
            ...this.state,
            options: [{
                label: "Please try another vehicle",
                options: [{ label: "No options", value: NO_OPTIONS, type: "" }]
            }],
            loadingOptionsMake: false,
            loadingOptionsModel: false,
            loadingOptionsBody: false,
            loadingOptionsCovs: false
        });
    }

    handleError() {
        alert("ERROR !!!");
    }

    handleOpen(type: string) {
        this.vinRecords = [];
        const removedValueType = type;
        const reducedSelectedOptions = [...this.state.selectedOptions];

        for (let i = 0; i < reducedSelectedOptions.length; i++) {
            if (reducedSelectedOptions[i].type === removedValueType) {
                reducedSelectedOptions.splice(i, reducedSelectedOptions.length);
                break;
            }
        }

        this.setState({ selectedOptions: reducedSelectedOptions, saveAndContinue: false }, () => {
            const newVehicleStep = this.vehicleExplorer.findStepByType(removedValueType);
            const lastSelectedValue = 0 < reducedSelectedOptions.length
                ? reducedSelectedOptions[reducedSelectedOptions.length - 1].value
                : "";
            if (newVehicleStep) {
                newVehicleStep.handler(lastSelectedValue);
            } else {
                this.handleError();
            }
        });
    }

    handleChange = (newValues: ValueType<any>, action: ActionMeta<VehicleOption>) => {
        const lastSelectedOption = newValues;
        if (NO_OPTIONS === lastSelectedOption.value) return;
        const extendedSelectedOptions = [...this.state.selectedOptions, lastSelectedOption];
        this.setState({ selectedOptions: extendedSelectedOptions }, () => {
            if (!this.vehicleExplorer.handleNextStepFor(lastSelectedOption.type, lastSelectedOption.value)) {
                this.handleError();
            }
        });
    };

    formatMakeIconName(make: string) {
        return make.replace(/\s/g, "_");
    }

    openYearMenu = () => {
        this.setState({ menuYearIsOpen: true, menuMakeIsOpen: false, menuModelIsOpen: false, menuBodyIsOpen: false, isActive: true }, () => { this.selectYearRef.current?.focus(); });
    };

    openMakeMenu = () => {
        this.setState({ menuMakeIsOpen: true, menuModelIsOpen: false, menuBodyIsOpen: false, isActive: true }, () => { this.selectMakeRef.current?.focus(); });
    };

    openModelMenu = () => {
        this.setState({ menuModelIsOpen: true, menuBodyIsOpen: false, isActive: true }, () => { this.selectModelRef.current?.focus(); });
    };

    openBodyMenu = () => {
        this.setState({ menuBodyIsOpen: true, isActive: true }, () => { this.selectBodyRef.current?.focus(); });
    };

    openCoverageMenu = () => {
        this.setState({ menuCoverageIsOpen: true, isActive: true }, () => { this.selectCoverageRef.current?.focus(); });
    };

    render() {
        return (
            <div className="vehicle-row">
                <Row>
                    <Col sm={2}>
                        <Select
                            ref={this.selectYearRef}
                            options={this.state.options.filter(x => x.options.filter(o => o.type === VEHICLE_OPTION_TYPES.YEAR).length > 0)}
                            value={this.state.selectedOptions.filter(x => x.type === VEHICLE_OPTION_TYPES.YEAR)[0]}
                            placeholder={"Year..."}
                            onFocus={this.openYearMenu}
                            menuIsOpen={this.state.menuYearIsOpen && this.state.isActive}
                            onMenuOpen={() => { this.handleOpen(VEHICLE_OPTION_TYPES.YEAR) }}
                            onChange={this.handleChange}
                            isSearchable={false}
                            blurInputOnSelect={false}
                            autoFocus={false}
                            isClearable={false}
                            isDisabled={this.props.updatingStore}
                        />
                        {
                            null != this.props.errors && validationUtils.hasValidationErrorFor(this.props.errors, "vehicle.year") && !this.state.vehicle.year
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "vehicle.year")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={2}>
                        <Select
                            ref={this.selectMakeRef}
                            options={this.state.options.filter(x => x.options.filter(o => o.type === VEHICLE_OPTION_TYPES.MAKE).length > 0)}
                            value={this.state.selectedOptions.filter(x => x.type === VEHICLE_OPTION_TYPES.MAKE)[0]}
                            placeholder={"Make..."}
                            onFocus={this.openMakeMenu}
                            menuIsOpen={this.state.menuMakeIsOpen && this.state.isActive}
                            onMenuOpen={() => { this.handleOpen(VEHICLE_OPTION_TYPES.MAKE) }}
                            onChange={this.handleChange}
                            isSearchable={false}
                            blurInputOnSelect={false}
                            autoFocus={false}
                            isClearable={false}
                            isLoading={this.state.loadingOptionsMake}
                            isDisabled={this.props.updatingStore || this.state.menuYearIsOpen || this.state.selectedOptions.filter(x => x.type === VEHICLE_OPTION_TYPES.YEAR).length === 0}
                        />
                        {
                            null != this.props.errors && validationUtils.hasValidationErrorFor(this.props.errors, "vehicle.make") && isEmpty(this.state.vehicle.make)
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "vehicle.make")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={3}>
                        <Select
                            ref={this.selectModelRef}
                            options={this.state.options.filter(x => x.options.filter(o => o.type === VEHICLE_OPTION_TYPES.MODEL).length > 0)}
                            value={this.state.selectedOptions.filter(x => x.type === VEHICLE_OPTION_TYPES.MODEL)[0]}
                            placeholder={"Model..."}
                            onFocus={this.openModelMenu}
                            menuIsOpen={this.state.menuModelIsOpen && this.state.isActive}
                            onMenuOpen={() => { this.handleOpen(VEHICLE_OPTION_TYPES.MODEL) }}
                            onChange={this.handleChange}
                            isSearchable={false}
                            blurInputOnSelect={false}
                            autoFocus={false}
                            isClearable={false}
                            isLoading={this.state.loadingOptionsModel}
                            isDisabled={this.props.updatingStore || this.state.menuYearIsOpen || this.state.menuMakeIsOpen || this.state.selectedOptions.filter(x => x.type === VEHICLE_OPTION_TYPES.MAKE).length === 0}
                        />
                        {
                            null != this.props.errors && validationUtils.hasValidationErrorFor(this.props.errors, "vehicle.model") && isEmpty(this.state.vehicle.model)
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "vehicle.model")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={2}>
                        <Select
                            ref={this.selectBodyRef}
                            options={this.state.options.filter(x => x.options.filter(o => o.type === VEHICLE_OPTION_TYPES.BODY).length > 0)}
                            value={this.state.selectedOptions.filter(x => x.type === VEHICLE_OPTION_TYPES.BODY)[0]}
                            placeholder={"Body..."}
                            onFocus={this.openBodyMenu}
                            menuIsOpen={this.state.menuBodyIsOpen && this.state.isActive}
                            onMenuOpen={() => { this.handleOpen(VEHICLE_OPTION_TYPES.BODY) }}
                            onChange={this.handleChange}
                            isSearchable={false}
                            blurInputOnSelect={false}
                            autoFocus={false}
                            isClearable={false}
                            isLoading={this.state.loadingOptionsBody}
                            isDisabled={this.props.updatingStore || this.state.menuYearIsOpen || this.state.menuMakeIsOpen || this.state.menuModelIsOpen || this.state.selectedOptions.filter(x => x.type === VEHICLE_OPTION_TYPES.MODEL).length === 0}
                        />
                        {
                            null != this.props.errors && validationUtils.hasValidationErrorFor(this.props.errors, "vehicle.body") && isEmpty(this.state.vehicle.body)
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "vehicle.body")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={2}>
                        <Select
                            ref={this.selectCoverageRef}
                            options={this.state.options.filter(x => x.options.filter(o => o.type === VEHICLE_OPTION_TYPES.COVERAGES).length > 0)}
                            value={this.state.selectedOptions.filter(x => x.type === VEHICLE_OPTION_TYPES.COVERAGES)[0]}
                            placeholder={"Coverages..."}
                            onFocus={this.openCoverageMenu}
                            menuIsOpen={this.state.menuCoverageIsOpen && this.state.isActive}
                            onMenuOpen={() => { this.handleOpen(VEHICLE_OPTION_TYPES.COVERAGES) }}
                            onChange={this.handleChange}
                            isSearchable={false}
                            blurInputOnSelect={false}
                            autoFocus={false}
                            isClearable={false}
                            isLoading={this.state.loadingOptionsCovs}
                            isDisabled={this.props.updatingStore || this.state.menuYearIsOpen || this.state.menuMakeIsOpen || this.state.menuModelIsOpen || this.state.menuBodyIsOpen || this.state.selectedOptions.filter(x => x.type === VEHICLE_OPTION_TYPES.BODY).length === 0}
                        />
                        {
                            null != this.props.errors && validationUtils.hasValidationErrorFor(this.props.errors, "vehicle.coverages") && !this.state.vehicle.coverages
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.props.errors, "vehicle.coverages")}
                                </Form.Control.Feedback>
                                : null
                        }
                    </Col>
                    <Col sm={1}>
                        {
                            this.props.vehicleIndex > 0
                                ?
                                <Button
                                    className="btn-remove"
                                    onClick={() => { this.props.onVehicleDelete(this.props.vehicleIndex) }}
                                    disabled={this.props.updatingStore}>
                                    <i className="fas fa-trash"></i>
                                </Button>
                                :
                                null
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}

export default VehicleSelectByStep
